import { ProductState } from './state';

export const productsInitialState: ProductState = {
  list: [],
  coupons: [],
  productsExtraFeatures: [],
};
